const MAX_TENANTS_ERROR = "MAX_TENANTS must be a positive integer";

export function isValidMaxTenants(value: unknown): value is number {
  return typeof value === "number" && Number.isSafeInteger(value) && value > 0;
}

export function parseMaxTenants(raw: string | undefined): number {
  const value = Number(raw);
  if (!isValidMaxTenants(value)) {
    throw new Error(MAX_TENANTS_ERROR);
  }
  return value;
}

export function maxTenantsFromEnv(
  env: Record<string, string | undefined> = process.env
): number {
  if (env.MAX_TENANTS !== undefined) {
    return parseMaxTenants(env.MAX_TENANTS);
  }
  return 1;
}
